import React from 'react'
import styles from './styles'
import { Typography } from '@material-ui/core'
import LineTo from 'react-lineto';
import withStyles from '@material-ui/core/styles/withStyles'

const Labels = (props) => {

  const {
    answer,
    questionAnswer,
    isMobile,
    isEmulator,
    p2Top,
    p1Top,
    originP,
    originCorrectP,
    q1,
    q2,
    originQ,
    dotCorrectQ,
    classes
  } = props

  const setP2Label = () => {

    if (answer.includes('shifts left')){
      if (answer.includes('Demand')){
        if (isMobile)
          return questionAnswer?.supply === "flat" ? '68px' : '76px'
          // return  "76px"
        else if (isEmulator)
          return '58px'
        else
        // return '198px'
        return questionAnswer?.supply === "flat" ? '172px' : '198px'
      }else{
        if (isMobile)
          return questionAnswer?.supply === "flat" ? '120px' : questionAnswer.demand === "flat" ?  "53px" : '32px'
        else if (isEmulator)
          return '58px'
        else
        return questionAnswer?.supply === "flat" ? '120px' : questionAnswer.demand === "flat" ?  "135px" : '105px'
      }
    }else{
      if (answer.includes('Demand')){
        if (isMobile)
          return questionAnswer?.supply === "steep" ? '45px' : '45px'
        else if (isEmulator)
          return '102px'
        else
          // return '135px'
        return questionAnswer?.supply === "steep" ? '115px' : '135px'
      }else{
        if (isMobile)
          return "78px"
        else if (isEmulator)
          return '102px'
        else
          // return questionAnswer?.supply === "steep" ? '215px' : '185px'
          return questionAnswer?.demand === "steep" ? '230px' : '185px'
      }
    }
  }

  const setQ2Label = () => {
    if (answer.includes('shifts left')){
      if (answer.includes('Demand')){
      if (isMobile)
        return questionAnswer?.supply === "flat" ? '70px' : '80px'
        // return "80px"
      else if (isEmulator)
        return '112px'
      else
        // return '200px'
        return questionAnswer?.supply === "flat" ? '160px' : '200px'
      }else{
      if (isMobile)
        return questionAnswer?.supply === "flat" ? '40px' : questionAnswer.demand === "flat" ?  "45px" : '80px'
      else if (isEmulator)
        return '112px'
      else
        return questionAnswer?.supply === "flat" ? '40px' : questionAnswer.demand === "flat" ?  "130px" : '159px'
      }
    }else{
      if (answer.includes('Demand')){
        if (isMobile)
          return "110px"
        else if (isEmulator)
          return '165px'
        else
          // return '295px'
          return questionAnswer?.supply === "steep" ? '260px' : '295px'
      }else{
        if (isMobile)
          return "133px"
        else if (isEmulator)
          return '165px'
        else
        // return questionAnswer?.supply === "steep" ? '220px' : '330px'
        return questionAnswer?.demand === "steep" ? '230px' : '330px'
      }
    }
  }

  const setQ1Label = () => {
    if (answer.includes('shifts left')){
      if (answer.includes('Demand')){
        if (isMobile)
          return questionAnswer?.supply === "flat" ? '100px' : '105px'
          // return "105px"
          // return questionAnswer?.supply === "flat" ? '240px' : questionAnswer.demand === "flat" ?  "240px" : '210px'
        else if (isEmulator)
          return '112px'
        else
          return '240px'
      }else{
        if (isMobile)
          return questionAnswer?.supply === "flat" ? '40px' : questionAnswer.demand === "flat" ?  "100px" : '103px'
        else if (isEmulator)
          return '112px'
        else
          return questionAnswer?.supply === "flat" ? '240px' : questionAnswer.demand === "flat" ?  "240px" : '210px'
      }
    }
    else{
      if (answer.includes('Demand')){
        if (isMobile)
          return questionAnswer?.supply === "steep" ? '85px' : '90px'
        else if (isEmulator)
          return '112px'
        else
          // return '240px'
          return questionAnswer?.supply === "steep" ? '220px' : '240px'
      }else{
        if (isMobile)
          return "98px"
        else if (isEmulator)
          return '112px'
        else
        // return questionAnswer?.supply === "steep" ? '180px' : '240px'
        return questionAnswer?.demand === "steep" ? '190px' : '240px'
      }
    }
  }

  const setP1Label = () => {
    if (answer.includes('shifts left')){
      if (answer.includes('Demand')){
        if (isMobile)
          return questionAnswer?.supply === "flat" ? '53px' : '60px'
          // return "60px"
        else if (isEmulator)
          return '112px'
        else
          // return '160px'
          return questionAnswer?.supply === "flat" ? '148px' : '160px'
      }else{
        if (isMobile)
          return questionAnswer?.supply === "flat" ? '120px' : questionAnswer.demand === "flat" ?  "68px" : '60px'
        else if (isEmulator)
          return '112px'
        else
        return questionAnswer?.supply === "flat" ? '160px' : questionAnswer.demand === "flat" ?  "165px" : '170px'
      }
    }else{
      if (answer.includes('Demand')){
        if (isMobile)
          return questionAnswer?.supply === "steep" ? '60px' : '65px'
        else if (isEmulator)
          return '112px'
        else
          return '160px'
      }else{
        if (isMobile)
          return "55px"
        else if (isEmulator)
          return '112px'
        else
          // return questionAnswer?.supply === "steep" ? '135px' :'155px'
          return questionAnswer?.demand === "steep" ? '170px' :'155px'
      }
    }
  }

  const calcBorderWidth = () => {
    if (isMobile)
      return "3px"
    else
      return "4px"
  }

  return (
    <span className="animate__animated animate__fadeIn">
      <Typography className={classes.graphP1Lable} style={{ top: setP1Label() }}>P1</Typography>
      <Typography className={classes.graphP2Lable} style={{ top: setP2Label() }}>P2</Typography>

      <Typography className={classes.graphQ1Lable} style={{ left: setQ1Label() }}>Q1</Typography>
      <Typography className={classes.graphQ2Lable} style={{ left: setQ2Label(), bottom: answer.includes('Supply curve shifts right') && questionAnswer?.supply === "normal" && questionAnswer?.demand === "flat" && -5 }}>Q2</Typography>
      <>
        <div
          className={'P2'}
          style={{ position: 'absolute', top: p2Top }}
        />
        <div
          className={'P1'}
          style={{
            position: 'absolute',
            top: p1Top
          }}
        />

        <div
          className={'dotOriginP'}
          style={{
            position: 'absolute',
            top: originP.top,
            left: originP.left
          }}
        />
        <div
          className={'dotCorrectP'}
          style={{
            position: 'absolute',
            top: originCorrectP.top,
            left: originCorrectP.left
          }}
        />

        <LineTo
          from="dotCorrectP"
          to="P2"
          orientation='h'
          borderStyle='dashed'
          borderWidth={calcBorderWidth()}
          borderColor='#508a05'
          fromAnchor='20%'delay={true}
          className="animate__animated animate__fadeIn"
        />
        <LineTo
          from="dotOriginP"
          to="P1"
          orientation='h'
          borderStyle='dashed'
          borderWidth={calcBorderWidth()}
          borderColor='#003e4c'
          fromAnchor='20%'delay={true}
          className="animate__animated animate__fadeIn"
        />

        <div className={'Q1'} style={{ position: 'absolute', top: q1.top, left: q1.left }} />
        <div className={'Q2'} style={{ position: 'absolute', top: q2.top, left: q2.left }} />

        <div className={'dotOriginQ'} style={{ position: 'absolute', top: originQ.top, left: originQ.left }} />
        <div className={'dotCorrectQ'} style={{ position: 'absolute', top: dotCorrectQ.top, left: dotCorrectQ.left }} />

        <LineTo
          from="dotOriginQ"
          to="Q1"
          orientation='h'
          borderStyle='dashed'
          borderWidth={calcBorderWidth()}
          borderColor='#003e4c'
          fromAnchor='20%'delay={true}
          className="animate__animated animate__fadeIn"
        />
        <LineTo
          from="dotCorrectQ"
          to="Q2"
          orientation='h'
          borderStyle='dashed'
          borderWidth={calcBorderWidth()}
          borderColor='#508a05'
          fromAnchor='20%'delay={true}
          className="animate__animated animate__fadeIn"
        />
      </>
    </span>
  )
}

export default withStyles(styles)(Labels)
